module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Angela Hunt\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Angela Hunt is an award-winning author with more than three million copies of her books in print. She lives in Florida with her husband, Gary, and their two children.")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/SRTEBR/tc-custom/9781418512798.jpg?1708485128574",
      "alt": "This image is the cover for the book Canopy"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Canopy\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Deep in the lush and dangerous rain forests of Peru, Alexandra Pace and her team search determinedly for a cure for deadly diseases. One strain of the disease has already begun the process of ravaging Alexandra's own mind and body. Finding a cure is the only hope for her and for her daughter, who has almost certainly inherited the same disease.")]), _c('p', [_vm._v("Alex believes she is searching for a needle in a haystack until she meets Michael Kenway, a British doctor who lost his wife when \"mad cow disease\" ravaged Britain in the 1990's. He presents her with an incredible story--a patient suffering from the disease was cured by a mythical \"healing tribe\" living deep in the Amazon jungle. Reluctantly placing her faith in Michael, who is entirely too religious for her comfort, Alexandra and her team seek out an unreached indigenous group who may hold the cure not only for Alex, but also for the world.")]), _c('p', [_vm._v("Award-winning, best-selling author Angela Hunt combines the unique rainforest setting, modern science, and a thrilling race for a cure into a powerful message of faith and redemption.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Thomas Nelson\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0